import axios from "axios";

export default axios.create({
  // baseURL: "https://natterv2.nattersearch.com/api/",
  baseURL: "https://nattersearch.nattersearch.com/api/",
  responseType: "json",
});
